import { Button, clx, icon } from "@hm/fundamental"

interface InfoButtonProps {
	"data-cy"?: string
	className?: string
	titleClassName?: string
	title?: string
	onClick?: () => void
}

export const InfoButton = ({
	"data-cy": dataCy,
	className,
	titleClassName,
	title,
	onClick,
}: InfoButtonProps) => (
	<Button
		data-cy={dataCy}
		variant="tertiary"
		className={clx("shrink-0 max-md:!px-0", className)}
		icon={icon.mdiInformationOutline}
		onClick={onClick}
	>
		<span className={clx(titleClassName)}>{title}</span>
	</Button>
)
